import React, { useState } from 'react';
import emsIcon from '../../../assets/icons/ems-icon-black.png';
import fireStationIcon from  '../../../assets/icons/layers-icons/fire-station.png';
import hospitalIcon from  '../../../assets/icons/layers-icons/hospital.png';
import downArrowIcon from '../../../assets/icons/down-arrow.png';
import Tooltip from "@mui/material/Tooltip";
import FeatureLayerWidget from './FeatureLayerWidget';

export default function EmergencyStations(props) {
    const {
        map
    } = props;

    const [expanded, setExpanded] = useState(false);
    const [activeLayers, setActiveLayers] = useState([]);

    const emergencyStationLayers = [
        {
            name: 'Fire Stations',
            icon: fireStationIcon,
            id: 'Layer-emergency-stations-Fire Station-symbol'
        },
        {
            name: 'EMS',
            icon: hospitalIcon,
            id: 'Layer-emergency-stations-EMS-symbol'

        }
    ]

    return (
       <div className='weather-widgets-feature-layer-widget-expandable'>
            <Tooltip
                title='Displays the locations of fire and EMS stations, highlighting critical emergency response infrastructure for public safety and disaster management.'
                arrow
                placement='left'
                
            >
                <div 
                    className={activeLayers.length > 0 ? 'weather-widgets-widget-active' : 'weather-widgets-widget'}
                    style={{  zIndex: 24 }}
                    onClick={() => {
                        const layers = map.current.getStyle().layers;
                        const fireStationsLayerExists = layers.find((l) => l.id.includes('Layer-emergency-stations-Fire Station-symbol'));
                        const emsStationsLayerExists = layers.find((l) => l.id.includes('Layer-emergency-stations-EMS-symbol'));
                    
                        if (fireStationsLayerExists && emsStationsLayerExists) {
                            setExpanded((prevState) => !prevState);
                        }
                    }}                    
                >
                    <div className={activeLayers.length > 0 ? 'weather-widgets-widget-active-title' : 'weather-widgets-widget-title'}> 
                        <img 
                            src={downArrowIcon} 
                            className='weather-widgets-widget-arrow'
                            style={{
                                transition: 'transform 0.5s ease',
                                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                            }}
                        />
                        Emergency Facilities
                    </div>
                    <div className='weather-widgets-widget-img-container'>
                        <img 
                            src={emsIcon} 
                            className='weather-widgets-widget-img'
                        />
                    </div>
                </div>
            </Tooltip>
            {expanded &&
            <div 
                className='weather-widgets-feature-layer-widget-expandable-expanded'
                style={{ zIndex: 23 }}
                >
                {emergencyStationLayers.map((layer) => {
                   return (
                        <FeatureLayerWidget 
                            layer={layer}
                            map={map}
                            activeLayers={activeLayers}
                            setActiveLayers={setActiveLayers}
                        />
                   )
                })}
            </div>
            }
       </div>
    )
}
